export const COOKIES_PROP_NAME = 'robotImageIndex'
